class ConfigService {
  constructor() {
    this.defaultConfig = {
      API_URL: 'http://localhost:5134/api/', // Fallback only
      NOTIFICATION_API_URL: 'https://localhost:54191',
      NOTIFICATION_INBOX_MODE: 'my',
      VERSION: '1.0.0',
      ENVIRONMENT: 'development',
      TIMEOUT: 30000,
    };
  }

  getConfig() {
    // Priority order:
    // 1. Environment variable (REACT_APP_API_URL)
    // 2. window.APP_CONFIG (from public/config.js)
    // 3. Default config
    const envConfig = {};

    if (process.env.REACT_APP_API_URL) {
      envConfig.API_URL = process.env.REACT_APP_API_URL;
    }
    if (process.env.REACT_APP_NOTIFICATION_API_URL) {
      envConfig.NOTIFICATION_API_URL = process.env.REACT_APP_NOTIFICATION_API_URL;
    }

    return {
      ...this.defaultConfig,
      ...(window.APP_CONFIG || {}),
      ...envConfig,
    };
  }

  get apiUrl() {
    return this.getConfig().API_URL;
  }

  get notificationApiUrl() {
    return this.getConfig().NOTIFICATION_API_URL;
  }

  get notificationInboxMode() {
    return this.getConfig().NOTIFICATION_INBOX_MODE || 'my';
  }

  get version() {
    return this.getConfig().VERSION;
  }

  get environment() {
    return this.getConfig().ENVIRONMENT;
  }

  get timeout() {
    return this.getConfig().TIMEOUT;
  }
}

export const configService = new ConfigService();
